export const fanArtTitle="Fan Art"
export const fanartData=[
    {
        label:'Ever After High',
        path:'/pages/fanart/ever-after-high-redesign',
        component:'EverAfterHigh',
        previewimage:[
            {
                imageName:'Ever After High Redesign',
                imagePath:'/assets/images/projects/fanart/everafterhigh-ravem-outfits.png',
                projectPath:'/pages/fanart/ever-after-high-redesign'
            }
        ],
        projectimages:[
            {
                imageName:'Apple White Outfits',
                imagePath:'/assets/images/projects/fanart/everafterhigh-apple-outfits.png',
                imageDescription:'Apple White outfit ideas.'
            },
            {
                imageName:'Raven Queen Outfits',
                imagePath:'/assets/images/projects/fanart/everafterhigh-ravem-outfits.png',
                imageDescription:'Raven Queen outfit ideas.'
            },
            {
                imageName:'Head Designs',
                imagePath:'/assets/images/projects/fanart/everafterhigh-raven-head-designs.png',
                imageDescription:'I started off designing Raven first. So I was ideating some head shapes.'
            },
            {
                imageName:'Ever After High Screenshot redraw Flat',
                imagePath:'/assets/images/projects/fanart/everafterhigh-screenshot-redraw_01_flat.png',
                imageDescription:'This is a redraw of a screenshot from the show with my designs, but with flat color.'
            },
            {
                imageName:'Reference for the screenshot',
                imagePath:'/assets/images/projects/fanart/everafterhigh-screenshot-ref.jpg',
                imageDescription:'The screemshot used from the show.'
            },
        ]
    },
    {
        label:'Me, but in Different Shows',
        path:'/pages/fanart/me-but-shows',
        component:'MeButShow',
        previewimage:[
            {
                imageName:'Me, but in different shows',
                imagePath:'/assets/images/projects/fanart/mebutshow/ME-butSHOW.png',
                projectPath:'/pages/fanart/me-but-shows'
            }
        ],
        projectimages:[
            {
                imageName:'Me, but in different shows',
                imagePath:'/assets/images/projects/fanart/mebutshow/ME-butSHOW.png',
                imageDescription:'This started off as a trend on twitter and some people did get hired into the industry thanks to it. So I thought it would be fun.'
            },
            {
                imageName:'Loudhouse Me Sketch',
                imagePath:'/assets/images/projects/fanart/mebutshow/sketch01-loudhouse.png',
                imageDescription:'What if I was a character in Loud House. I chose a kid as a base because I am short and thought it would be funny'
            },
            {
                imageName:'Avatar Me sketch',
                imagePath:'/assets/images/projects/fanart/mebutshow/sketch02-atla.png',
                imageDescription:'I chose the air nomads as my bending nation because I grew up raised in Tibetan Buddhism, so the motifs that inspired the air nomads were the most familiar to me.'
            },
            {
                imageName:'Scooby Doo Me Sketch',
                imagePath:'/assets/images/projects/fanart/mebutshow/sketch03-scoobydoo.png',
                imageDescription:'I went with Daphne as a base but did look up typical 60s fashion to get a feel for what would fit in the show\'s universe.'
            },
            {
                imageName:'Fairly Odd Parents Me Sketch',
                imagePath:'/assets/images/projects/fanart/mebutshow/sketch04-fop.png',
                imageDescription:'There weren\'t too many SouthEast or East Asian characters I could use a base in the original series so I used Cosmo and Wanda as a base.'
            },
            {
                imageName:'Gravity Falls me sketch',
                imagePath:'/assets/images/projects/fanart/mebutshow/sketch05-gf.png',
                imageDescription:'I used Wendy as a base and Candy for the face since she was the only obviously Asian coded character.'
            },
            {
                imageName:'Owl House Me Character',
                imagePath:'/assets/images/projects/fanart/mebutshow/sketch06-oh.png',
                imageDescription:'I made myself a student of Hexside.'
            },
        ]

    },
    {
        label:'Hades style Study with Class of The Titans: Hephaestus',
        path:'/pages/fanart/hades-study-cott-hephaestus',
        component:'HadesStyleStudy',
        previewimage:[
            {
                imageName:'Hades style study but COTT',
                imagePath:'/assets/images/projects/fanart/hadesstudy/hephcott_butHades.png',
                projectPath:'/pages/fanart/hades-study-cott-hephaestus'
            }
        ],
        projectimages:[
            {
                imageName:'COTT Hephaestus in the Hades Style',
                imagePath:'/assets/images/projects/fanart/hadesstudy/hephcott_butHades.png',
                imageDescription:'In honor of SuperGiant Games\'s Hades II, I wanted to try my hand at studying their style using one of my favorite characters from one of my earliest exposures to Greek mythology.'
            },
            {
                imageName:'Hephaestus from Hades II',
                imagePath:'/assets/images/projects/fanart/hadesstudy/hades.jpg',
                imageDescription:'He is the primary base for how I would approach this style study.'
            },
            {
                imageName:'Hephaestus reference',
                imagePath:'/assets/images/projects/fanart/hadesstudy/hephcott01.jpg',
                imageDescription:'One of the reference pictures for class of the titans Heph'
            },
            {
                imageName:'Hephaestus reference 2',
                imagePath:'/assets/images/projects/fanart/hadesstudy/hephcott02.jpg',
                imageDescription:'Another reference picture of class of the titans Heph'
            },
        ]

    },
    {
        label:'Nanaco Yashiro Study in Owl House: Luz and Amity',
        path:'/pages/fanart/nanacoyashiro-study-owl-house-luz-amity',
        component:'NanacoStudy',
        previewimage:[
            {
                imageName:'Nanaco Yashiro Study with Owl House',
                imagePath:'/assets/images/projects/fanart/nanacostudy/nanacoYashiroStudy_amity.png',
                projectPath:'/pages/fanart/nanacoyashiro-study-owl-house-luz-amity'
            }
        ],
        projectimages:[
            {
                imageName:'Luz Noceda',
                imagePath:'/assets/images/projects/fanart/nanacostudy/nanacoYashiroStudy_luz.jpg',
                imageDescription:'I used the outfit from the episode with the brawl Amity wanted to enter (and Luz of course). The Yashiro reference can be seen here: \n <Link href="https://www.instagram.com/p/Cj-j6gGuDRA/?img_index=1">instagram post with the reference</Link>'
            },
            {
                imageName:'Amity Blight',
                imagePath:'/assets/images/projects/fanart/nanacostudy/nanacoYashiroStudy_amity.png',
                imageDescription:'Yashiro\'s study is very intricate so I tried adding more details to Amity\'s outfit. The reference can be seen here: \n <Link href="https://www.instagram.com/p/Cj24uD4ONrC/?img_index=1">instagram post with reference</Link>' 
            },
        ]

    },
    {
        label:'Monster High Redesign',
        path:'/pages/fanart/monster-high-redesign',
        component:'MonsterHigh',
        previewimage:[
            {
                imageName:'Monster High Redesign',
                imagePath:'/assets/images/projects/fanart/monsterhigh-redesign/monsterHigh_frankie2.png',
                projectPath:'/pages/fanart/monster-high-redesign',
            }
        ],
        projectimages:[
            {
                imageName:'Frankie Stein',
                imagePath:'/assets/images/projects/fanart/monsterhigh-redesign/monsterHigh_frankie2.png',
                imageDescription:'I used a mix of different generation designs to get this one. Needed Frankie to stand out as the main character of the franchise (to my knowlege in gen 1 anyway).'
            },
            {
                imageName:'Draculaura',
                imagePath:'/assets/images/projects/fanart/monsterhigh-redesign/monsterHigh_draculaura.png',
                imageDescription:'I also mixed a few generation designs, but added some gothic lolita (casual) in the mix to make it more her.'
            },
            {
                imageName:'Lagoona Blue',
                imagePath:'/assets/images/projects/fanart/monsterhigh-redesign/monsterHigh_lagoona.png',
                imageDescription:'This character gave a more sporty image so that got added to the mix of generations to inspire this design.'
            },
        ]

    },
    {
        label:'Princess Anastacya from Blood Heir',
        path:'/pages/fanart/blood-heir-princess',
        component:'PrincessAna',
        previewimage:[
            {
                imageName:'Blood Heir Fan Art',
                imagePath:'/assets/images/projects/fanart/bloodheir/AlmostAnEmpress.png',
                projectPath:'/pages/fanart/blood-heir-princess',
            }
        ],
        projectimages:[
            {
                imageName:'Princess Anastastacya Mikhailov',
                imagePath:'/assets/images/projects/fanart/bloodheir/anatastacyaMikhailov-final_00.png',
                imageDescription:'A lighting experiment that reminisces of old nobility portraits.'
            },
            {
                imageName:'Ana gets ready for the masquerade',
                imagePath:'/assets/images/projects/fanart/bloodheir/blood-heir_fanart_final_20.png',
                imageDescription:'This is my interpretation of a scene in the Blood Heir book.'
            },
            {
                imageName:'Almost An Empress',
                imagePath:'/assets/images/projects/fanart/bloodheir/AlmostAnEmpress.png',
                imageDescription:'I actually used the Princess Anastascya portrait for an art contest my friend sent me. I added some glitch effects to try to add the theme of the contest ("womanhood"). I didn\'t win any showcase or anything, but I\'m still glad of how this turned out. '
            },
        ]

    },
    {
        label:'Webtoon Characters as Animal Crossing Villagers',
        path:'/pages/fanart/webtoon-characters-animal-crossing-villagers',
        component:'WebtoonAC',
        previewimage:[
            {
                imageName:'Webtoon characters in ACNH',
                imagePath:'/assets/images/projects/fanart/aro-webtoon.jpg',
                projectPath:'/pages/fanart/webtoon-characters-animal-crossing-villagers',
            }
        ],
        projectimages:[
            {
                imageName:'Aro, the witch from The Witch and The Bull',
                imagePath:'/assets/images/projects/fanart/aro-webtoon.jpg',
                imageDescription:'Aro got bunny because she\'s an optimistic person.'
            },
            {
                imageName:'Isran from Heir\'s Game',
                imagePath:'/assets/images/projects/fanart/isran-webtoon.jpg',
                imageDescription:'Isran got wolf because in the story he\'s a chill dude, even with his trauma and introverted tendencies.'
            },
            {
                imageName:'Theuden from Heir\'s Game',
                imagePath:'/assets/images/projects/fanart/theuden3-webtoon.jpg',
                imageDescription:'Theuden got cat because he is very pampered and a rich boy.'
            },
        ]

    },
    {
        label:'Avatar the Last Airbender screen redraw',
        path:'/pages/fanart/atla-screen-redraw',
        component:'Avatar',
        previewimage:[
            {
                imageName:'ATLA screenshot redraw',
                imagePath:'/assets/images/projects/fanart/toph-desert.jpg',
                projectPath:'/pages/fanart/atla-screen-redraw',
            }
        ],
        projectimages:[
            {
                imageName:'Toph is blind and in the desert',
                imagePath:'/assets/images/projects/fanart/toph-desert.jpg',
                imageDescription:'I\'ll have to look up the episode but this scene is from the time the gaang goes to find that library maintained by the big owl.'
            },
        ]

    },
    {
        label:'Owl House Tarot: Hunter',
        path:'/pages/fanart/owl-house-tarot-hunter',
        component:'OHTarotHunter',
        previewimage:[
            {
                imageName:'Owl House Tarot',
                imagePath:'/assets/images/projects/fanart/thefoolcard.png',
                projectPath:'/pages/fanart/owl-house-tarot-hunter',
            }
        ],
        projectimages:[
            {
                imageName:'The Fool Card',
                imagePath:'/assets/images/projects/fanart/thefoolcard.png',
                imageDescription:'This is the first card. The fool. I based the design on a deck I had in my posession (will have to look who designed that deck- my bad). Hunter made sense for the fool because of his character joourney. Other characters are still in sketch form (and I\'ll have to hunt for that sketchbook if I don\'t want to start those over :('
            },
        ]

    },
    {
        label:'Theuden in the rain',
        path:'/pages/fanart/theuden-rain',
        component:'TheudenRain',
        previewimage:[
            {
                imageName:'Theuden in the Rain',
                imagePath:'/assets/images/projects/fanart/theuden2-webtoon.jpg',
                projectPath:'/pages/fanart/theuden-rain',
            }
        ],
        projectimages:[
            {
                imageName:'Theuden in the rain searching',
                imagePath:'/assets/images/projects/fanart/theuden2-webtoon.jpg',
                imageDescription:'This was a recreation of a webtoon panel (from Heir\'s Game) because I sometimes like to play with lineless work. I believe Theuden was trying to sneak out of the palace or something.'
            },
            {
                imageName:'Theuden in the rain, found',
                imagePath:'/assets/images/projects/fanart/theuden-webtoon.jpg',
                imageDescription:'This is another recretion of a panel from the webtoon Heir\'s Game because it\'s one of my personal favorites. I don\'t remember the context too much but I do know he was talking to Isran (another character and love interest).'
            },
        ]

    },
    {
        label:'Alex in Zombieland Portrait',
        path:'/pages/fanart/alex-zombieland-portrait',
        component:'AlexZombie',
        previewimage:[
            {
                imageName:'Boyfriend of the Dead fanart',
                imagePath:'/assets/images/projects/fanart/alex-webtoon.jpg',
                projectPath:'/pages/fanart/alex-zombieland-portrait',
            }
        ],
        projectimages:[
            {
                imageName:'Alexander The Great',
                imagePath:'/assets/images/projects/fanart/alex-webtoon.jpg',
                imageDescription:'She\'s named Alex in the webtoon, but the zombies know her as Alexander the Great because of how ruthless she is in beating said zombies. So I wanted to channel that through the portrait by emulating portraits of military generals, and add some blood spatter for some pizazz.\n Visit her instagram here:\n <Link href="https://www.instagram.com/alexinzombieland/?hl=en">Alex\'s instagram</Link>'
            },
        ]

    },
]